import React, { useState, useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";
import { useDispatch, useSelector } from "react-redux";
import { getMyTrips } from "../../store/actions/myTripsActions";
import { useParams } from "react-router";
import TripCard from "../../components/tripCard/tripCard";
// Converted modular CSS to Tailwind utilities
import { CircularProgress } from "@material-ui/core";
import { BOOKING_TYPES } from "../../store/constants/baseUrl";
import TripLoading from "../../components/Booking/TripLoading";


const MyTrips = () => {
  //my trip object
  const [myTripsState, setmyTripsState] = useState();
  const [filter, setfilter] = useState("All");
  const [selectedItem, setSelectedItem] = useState("All");
  // dispatch redux actions
  const dispatch = useDispatch();
  // getting userId from params
  const { userId } = useParams();
  // calling my trips state
  const { myTripsInfo } = useSelector((state) => state.myTrips);
  // calling my trip API through action
  useEffect(() => {
    try {
      dispatch(getMyTrips(userId, filter));
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
    }
  }, [filter]);
  // populating my trip state
  useEffect(() => {
    try {
      if (myTripsInfo) {
        setmyTripsState(myTripsInfo);
      }
    } catch (error) {
      Sentry.captureException(error);
      console.log(error);
      setmyTripsState([]);
    }
  }, [myTripsInfo]);
  // no global click handlers needed for pill filters
  const FILTERS = BOOKING_TYPES;

  return (
    <div className="max-w-6xl mx-auto mt-4 px-3">
      <div className="w-full">
          <div className="mb-4">
            <h1 className="text-[24px] text-[#211F59] font-semibold">My bookings</h1>
            <div className="flex items-center gap-2 mt-3 hide-scrollbar flex-nowrap whitespace-nowrap overflow-x-auto overflow-y-visible py-1" style={{ WebkitOverflowScrolling: 'touch', msOverflowStyle: 'none' }}>
              {FILTERS.map((f) => (
                <button
                  key={f.value}
                  onClick={() => {
                    setfilter(f.value);
                    setSelectedItem(f.option);
                  }}
                  className={`flex-shrink-0 whitespace-nowrap text-[16px] px-3 py-1 rounded-full ${
                      selectedItem === f.option
                        ? "bg-[#211F59] text-white"
                        : "bg-white text-[#6D6B8A]"
                    }`}
                style={{ border: "1px solid #211F59" }}
                >
                  {f.option}
                </button>
              ))}
            </div>
          </div>

        <div className="w-full  space-y-3">
          {myTripsState ? (
            myTripsState.length === 0 ? (
              <div className="flex flex-col items-center text-center max-w-[520px] mx-auto py-4">
                <img src="/Clip path group.svg" alt="No bookings" className="md:w-[320px] md:h-auto mb-6" />
                <h2 className="text-[16px] md:text-[22px] text-[#211F59] font-semibold mb-2 self-start">You don’t have any bookings yet</h2>
                <p className="text-[#211F59] text-start max-w-[520px] text-[12px]  md:text-[15px]">
                  Once you book a job with Moovez, you’ll see your upcoming and past bookings here. Booking only takes a few minutes.
                </p>
              </div>
            ) : (
              myTripsState?.map((trip, idx) => (
                <TripCard key={trip?.id || trip?.bookingId || idx} data={trip} />
              ))
            )
          ) : (
             <TripLoading/>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyTrips;
